import { useContext, useEffect } from "react";
import { useState } from "react";
import LocationContext from "@/common/Contexts/LocationContext";
import { SECURE_COOKIE } from "@globalConfig";
import useCookieClient from "@hooks/useCookieClient";
import { checkTestFlag } from "@/common/config/websiteConfig";
var COOKIE_NANE = "webview_v2";
function getLocationParams(search) {
  return new URLSearchParams(search);
}
export default function useIsWebView() {
  if (__IS_SSR__) {
    var locationContext = useContext(LocationContext);
    var _params = getLocationParams(locationContext.search || "");
    return !!_params.get("webview");
  }
  var params = getLocationParams(location.search);
  var _useState = useState(!!params.get("webview")),
    isWebView = _useState[0],
    setIsWebView = _useState[1];
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient,
    setCookieClient = _useCookieClient.setCookieClient;
  useEffect(function () {
    if (checkTestFlag("TEST_WEBVIEW") !== undefined) {
      return setIsWebView(checkTestFlag("TEST_WEBVIEW"));
    }
    if (getCookieClient(COOKIE_NANE)) {
      setIsWebView(true);
    } else if (isWebView) {
      setCookieClient(COOKIE_NANE, "1", {
        path: "/",
        maxAge: 3600 * 24 * 365 * 10,
        // Cookie will expire after 10 years
        sameSite: true,
        secure: SECURE_COOKIE
      });
    } else if (isWebView) {
      console.warn('ignored webview due to user agent');
    }
  }, [isWebView]);
  return isWebView;
}